<template>
    <Modal class="modal-calculate-creating">
        <h3 slot="header">{{ value }}</h3>
        <div slot="body"><LoadingDots /></div>
        <div slot="footer"></div>
    </Modal>
</template>

<script>
import Modal from './../Modal';
import LoadingDots from '../LoadingDots';

export default {
    props: ['value'],
    components: {
        Modal,
        LoadingDots,
    },
};
</script>

<style lang="scss">
// Permet de ne pas afficher le bouton de fermeture
.modal-calculate-creating .dismiss-icon {
    display: none;
}
</style>
